module.exports = __webpack_public_path__ + "static/desktop/img/design-mobile-photobook.c270037d.png";